// One scheduler for all page reads. Hidden/offline pages issue no scheduled reads.
type Task={work:()=>unknown|Promise<unknown>;interval:number;next:number;busy:boolean;failures:number}
const tasks=new Map<number,Task>()
let sequence=0,timer:ReturnType<typeof setInterval>|undefined,running=false
export function pollDelay(interval:number,failures:number){return Math.min(300000,interval*2**Math.min(failures,6))}
async function tick(){
 if(running||document.visibilityState!=='visible'||!navigator.onLine)return
 running=true
 try{for(const task of tasks.values()){
  if(document.visibilityState!=='visible'||!navigator.onLine)break
  if(task.busy||task.next>Date.now())continue
  task.busy=true
  try{const result=await task.work();task.failures=result===false?task.failures+1:0}catch{task.failures++}
  finally{task.busy=false;task.next=Date.now()+pollDelay(task.interval,task.failures)}
 }}finally{running=false}
}
export function sharedPoll(work:()=>unknown|Promise<unknown>,interval:number,immediate=false){
 const id=++sequence,delay=Math.max(interval,1000)
 tasks.set(id,{work,interval:delay,next:immediate?0:Date.now()+delay,busy:false,failures:0})
 timer??=setInterval(()=>void tick(),1000)
 if(immediate)void tick()
 return id
}
export function stopPoll(id:number){tasks.delete(id);if(!tasks.size&&timer){clearInterval(timer);timer=undefined}}
